<ng-container>
    <div class="grid-4col input-grid-gaps">
        <app-check-input
            [form]="form()"
            id="icDph"
            prefix="organization-settings.mado."
            class="fr-4"
        ></app-check-input>

        <app-text-input
            [form]="form()"
            id="displayedName"
            prefix="organization-settings.mado."
        ></app-text-input>
        <app-select-input
            [form]="form()"
            id="organizationType"
            prefix="organization-settings.mado."
            [staticOptions]="organizationTypeOptions"
        ></app-select-input>
    </div>
</ng-container>
